// Live countdown for the "Special Products" promo trio header.
// Counts down to the next 23:59:59 local time. When zero is reached
// it resets to another 24-hour window so the promo always shows
// time remaining.

(function () {
    const pad = (n) => String(n).padStart(2, '0');

    function endOfNextDay(now) {
        const d = new Date(now);
        d.setHours(23, 59, 59, 999);
        if (d.getTime() <= now) d.setDate(d.getDate() + 1);
        return d.getTime();
    }

    function init() {
        const blocks = document.querySelectorAll('[data-promo-countdown]');
        if (!blocks.length) return;
        const els = Array.from(blocks).map((el) => ({
            el,
            h: el.querySelector('[data-promo-hours]'),
            m: el.querySelector('[data-promo-mins]'),
            s: el.querySelector('[data-promo-secs]'),
        }));

        let target = endOfNextDay(Date.now());

        const tick = () => {
            const now = Date.now();
            let remaining = target - now;
            if (remaining <= 0) {
                target = endOfNextDay(now);
                remaining = target - now;
            }
            const hours = Math.floor(remaining / 3_600_000);
            const mins  = Math.floor((remaining % 3_600_000) / 60_000);
            const secs  = Math.floor((remaining % 60_000) / 1000);
            els.forEach(({ h, m, s }) => {
                if (h) h.textContent = pad(hours);
                if (m) m.textContent = pad(mins);
                if (s) s.textContent = pad(secs);
            });
        };

        tick();
        setInterval(tick, 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
